// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"246fa76c","498":"05d18740","703":"bbe0f06f"}[chunkId] + ".chunk.js";
};